// Lightweight CSS-only spinner used as Suspense fallback during initial load,
// so the heavy Lottie web component (~600KB WASM) doesn't block first paint.
interface CssSpinnerProps {
  size?: number;
  className?: string;
}

export const CssSpinner = ({ size = 48, className = "" }: CssSpinnerProps) => (
  <div
    className={`inline-block animate-spin rounded-full border-4 border-muted border-t-primary ${className}`}
    style={{ width: size, height: size }}
    aria-label="Loading"
    role="status"
  />
);

export default CssSpinner;
